import { dialog } from "nq-component";
import BaseFormPresenter from "../../../base/BaseFormPresenter";
import { html, p } from "framer-motion/client";

class WalkInFormPresenter extends BaseFormPresenter {
  constructor(
    view,
    upsertUseCase,
    signOutUseCase,
    findObjectUseCase,
    getObjectUseCase
  ) {
    super();
    this.view = view;
    this.upsertUseCase = upsertUseCase;
    this.signOutUseCase = signOutUseCase;
    this.findObjectUseCase = findObjectUseCase;
    this.getObjectUseCase = getObjectUseCase;
    this.personal = {};
    this.employmentBackground = [];
    this.characterref = [];
    this.recruiter = null;
    this.position = null;
    this.deploymentType = "";

    this.onChangeEmployment = this.onChangeEmployment.bind(this);
    this.onChangecharacteref = this.onChangecharacteref.bind(this);
  }

  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  componentDidMount() {
    this.init();
    this.getObjects();
    this.getJobPosts();
  }
  init() {
    this.limit = 20;
    this.where = {};
    this.search = {};
    this.filter = {};
    this.include = ["all"];
    this.keys = undefined;
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }

  async getObjects() {
    const collection = "users";
    const query = {
      include: ["employee"],
      where: { "roles.id": "Recruiter" },
    };

    try {
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);

      // const employeeIds = objects.map((item) => item.employee.id);

      // const roleIds = { employeeIds };

      this.view.setState({ recruiters: objects });
    } catch (error) {
      console.error("Error in findObjects:", error);
      this.view.showError(error);
    } finally {
      this.progress = false;
    }
  }

  async getJobPosts() {
    const collection = "job_posting";
    const now = new Date();
    const utcMidnight = new Date(now.getTime() + 8 * 60 * 60 * 1000);
    utcMidnight.setUTCHours(0, 0, 0, 0);

    const todayISO = utcMidnight.toISOString();

    try {
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, {
        where: { deadline: { $gte: todayISO } },
      });

      this.view.setState({ jobPositions: objects });
      console.log(objects);
    } catch (error) {
      console.error("Error in findObjects:", error);
      this.view.showError(error);
    } finally {
      this.progress = false;
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.recruiters !== this.state.recruiters) {
      this.init();
    }
  }

  reset() {
    if (this.view.state.recruiters.length === 0) {
      this.view.setState({ recruiters: [] });
    }
  }

  onChangeEmployment(value, field, id = crypto.randomUUID()) {
    let index = this.employmentBackground.findIndex((emp) => emp.id === id);
    if (index === -1) {
      this.employmentBackground.push({ id });
      index = this.employmentBackground.length - 1;
    }
    this.employmentBackground[index][field] = value;
  }

  onChangecharacteref(value, field, id = crypto.randomUUID()) {
    let index = this.characterref.findIndex((emp) => emp.id === id);
    if (index === -1) {
      this.characterref.push({ id });
      index = this.characterref.length - 1;
    }
    this.characterref[index][field] = value;
  }

  // onChangePersonal(value, field) {
  //   this.personal[field] = value;
  //   const isAddressSame = this.view.state.isAddressSame;
  // }

  deleteImage() {
    delete this.personal["image1"];
  }

  syncAddress() {
    this.personal["permanent_houseNumber"] =
      this.personal["present_houseNumber"];
    this.personal["permanent_street"] = this.personal["present_street"];
    this.personal["permanent_subdivision"] =
      this.personal["present_subdivision"];
    this.personal["permanent_barangay"] = this.personal["present_barangay"];
    this.personal["permanent_city"] = this.personal["present_city"];
    this.personal["permanent_province"] = this.personal["present_province"];
    this.personal["permanent_zipCode"] = this.personal["present_zipCode"];
    this.personal["telephone"] = this.personal["present_telephone"];
  }
  onChangePersonal(value, field) {
    this.personal[field] = value;

    this.view.setState({ personal: { ...this.personal } });
    console.log(this.personal);
  }

  onChangeRecruiter(event) {
    const selectedRecruiterId = event.target.value;
    this.recruiter = selectedRecruiterId;
  }

  onChangeJobPosition(event) {
    const jobId = event.target.value;
    const { jobPositions } = this.view.state;

    const selectedJob = jobPositions.find((job) => job.id === jobId);

    if (selectedJob) {
      this.position = selectedJob.positionTitle;
      const deploymentType = selectedJob.deploymentType || "N/A";
      this.deploymentType = deploymentType;
    } else {
      console.warn("Job not found for ID:", jobId);
    }
  }

  removeEmployment(id) {
    delete this.employmentBackground[id];
  }

  removeCharacterRef(id) {
    delete this.characterref[id];
  }

  validateInputs() {
    const uploadedImage = this.view.state.image;
    if (!this.personal["coe"] || this.personal["coe"].trim() === "") {
      return false;
    }

    if (
      !this.personal["trainingCertificate"] ||
      this.personal["trainingCertificate"].trim() === ""
    ) {
      return false;
    }

    return true;
  }

  async getRecruiter(id) {
    if (!id) return null;

    const collection = "users";
    const params = { include: ["all"] };

    try {
      this.view.showProgress();
      return await this.getObjectUseCase.execute(collection, id, { params });
    } catch (error) {
      this.view.showError(error);
      return null;
    } finally {
      this.view.hideProgress();
    }
  }

  async submit() {
    const recruiterId = this.recruiter;
    const user = this.view.getCurrentUser();
    const { isAddressSame } = this.view.state;
    const { ...personalInfo } = this.personal;
    const recruitersData = await this.getRecruiter(this.recruiter);
    if (isAddressSame) {
      this.syncAddress();
    }
    try {
      this.view.showProgress();

      const employmentReferences = await Promise.all(
        this.employmentBackground.map(async (employment) => {
          const result = await this.upsertUseCase.execute(
            "employment_background",
            employment
          );
          return result;
        })
      );

      const characterrefData = await Promise.all(
        this.characterref.map(async (ref) => {
          const result = await this.upsertUseCase.execute(
            "character_references",
            ref
          );
          return result;
        })
      );

      const referenceNo = this.view.generateReferenceNumber();
      this.personal["image1"] = this.view.state.image;
      let application = {};
      if (!recruiterId) {
        application = {
          ...this.personal,
          status: "For Interview",
          applicant: {
            id: user?.id,
          },
          interviewCoordinator: "walkIn",
          deploymentType: this.deploymentType,
          positionApplied: this.position,
          referenceNumber: referenceNo,
          employmentBackground: employmentReferences,
          characterReferences: characterrefData,
        };
      } else {
        application = {
          ...this.personal,
          status: "For Interview",
          recruiter: {
            id: recruiterId,
          },
          applicant: {
            id: user?.id,
          },
          interviewCoordinator: "walkIn",
          deploymentType: this.deploymentType,
          positionApplied: this.position,
          referenceNumber: referenceNo,
          employmentBackground: employmentReferences,
          characterReferences: characterrefData,
        };
        const walkInapplication = {
          name: `${personalInfo.firstName} ${personalInfo.lastName}`,
          startDate: new Date().toISOString(),
          endDate: new Date(
            new Date().setDate(new Date().getDate() + 1)
          ).toISOString(),
          status: "waiting",
          recruiter: { id: recruitersData.id },
          employeeId: recruitersData.id,
          window: recruitersData?.window,
          recruiterFirstName: recruitersData.employee.firstName,
          recruiterMiddleName: recruitersData.employee.middleName,
          recruiterLastName: recruitersData.employee.lastName,
          positionApplied: this.position,
        };
        await this.upsertUseCase.execute("queue", walkInapplication);
      }

      const applicationData = await this.upsertUseCase.execute(
        "walkIn_applicants",
        application
      );

      this.view.showSuccessSnackbar(
        "The application form has been successfully submitted! Please wait for an email regarding your interview schedule.",
        "Application Submitted"
      );
      const isWalkIn = true;
      if (applicationData) {
        this.view.navigateTo(`/optioncard`);
      }
    } catch (error) {
      this.view.hideProgress();
      this.view.showError(error);
    }
  }

  removeSelectedJobs() {
    localStorage.removeItem("selectedJobs");
  }
  onClickSignOut() {
    const options = {
      title: "Confirm",
      message: "Are you sure you want to sign out?",
      positiveButton: "SIGN OUT",
    };

    this.view
      .showDialog(options)
      .then(() => this.signOutUseCase.execute())
      .then(() => {
        localStorage.removeItem("selectedJobs");
        localStorage.removeItem("user");
        this.view.navigateTo("/optioncard");
      })
      .catch((error) => {
        this.view.showError(error);
      });
  }
}

export default WalkInFormPresenter;
